import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Client, Communicator } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { ActiveObject, resolve } from '../../Container';
import { Wrapper } from '../../Wrapper';
import { Camera } from '../../canvas/Camera';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { confettiScreen } from '../../onboarding/OnboardingCommands';
import { ToastHub } from '../toast/ToastHub';
import { Buzzer } from './Buzzer';
import { ChickenEgg } from './ChickenEgg';
import { CowEgg } from './CowEgg';
import { ThrowEgg } from './ThrowEgg';

export class BuzzController extends ActiveObject {

    @resolve(AudioManager) private audio: AudioManager;
    @resolve(Camera) private camera: Camera;
    @resolve(Communicator) private comms: Communicator;
    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;
    @resolve(ToastHub) private toast: ToastHub;
    @resolve(WidgetManager) private widgets: WidgetManager;
    @resolve(Wrapper) private wrapper: Wrapper;

    private timeOfLastBuzz = 0;

    public start() {
        this.burden(
            this.comms.recv('buzz', this.inBuzz),
        );
    }

    public buzz(buzzer: Buzzer) {
        if (!buzzer.alive || !buzzer.sound) return;

        const timeSinceLast = Date.now() - this.timeOfLastBuzz;
        if (timeSinceLast < 3000) return;

        this.comms.send('buzz', { buzzerId: buzzer.id, sound: buzzer.sound });
        this.toast.invokeAndSend('buzzer:buzz', {});

        this.playSound(buzzer.sound);
        this.timeOfLastBuzz = Date.now();
    }

    private inBuzz = (_sender: Client, data: any) => {
        const timeSinceLast = Date.now() - this.timeOfLastBuzz;
        if (timeSinceLast < 3000) return;

        this.playSound(data.sound);
        this.timeOfLastBuzz = Date.now();
    };

    private playSound(sound: string) {
        this.audio.play(sound);

        if (sound.toLowerCase().includes('inception')) {
            this.wrapper.setEffect('shake', 3000);
        }
        if (sound.toLowerCase().includes('cow')) {
            this.showCow();
        }
        if (sound.toLowerCase().includes('chicken')) {
            this.showChicken();
        }
        if (sound.toLowerCase().includes('throw')) {
            this.showThrow();
        }
        if (sound.toLowerCase().includes('stinger') || sound.toLowerCase().includes('fanfare')) {
            this.dispatch(confettiScreen, [0, .6, 45, 1000]);
            this.dispatch(confettiScreen, [1, .6, 135, 1000]);
        }
    }

    private showCow() {
        const id = uuid();
        const at = this.camera.getViewFrame().pointAt(1, .5);
        const cont = this.widgets.createContainer({
            name: id,
            position: ['absolute', { at, relativeTo: 'view' }],
            style: 'none',
        });
        cont.add(this.widgets.createInline({
            ui: CowEgg
        }));
        this.widgets.add(cont);
        this.scheduler.timeout(id, 3000, () => {
            this.widgets.remove(cont);
        });
    }

    private showChicken() {
        const id = uuid();
        const at = this.camera.getViewFrame().pointAt(1, .5);
        const cont = this.widgets.createContainer({
            name: id,
            position: ['absolute', { at, relativeTo: 'view' }],
            style: 'none',
        });
        cont.add(this.widgets.createInline({
            ui: ChickenEgg
        }));
        this.widgets.add(cont);
        this.scheduler.timeout(id, 3000, () => {
            this.widgets.remove(cont);
        });
    }

    private showThrow() {
        const id = uuid();
        const at = this.camera.getViewFrame().pointAt(0, .25);
        const cont = this.widgets.createContainer({
            name: id,
            position: ['absolute', { at, relativeTo: 'view' }],
            style: 'none',
        });
        cont.add(this.widgets.createInline({
            ui: ThrowEgg
        }));
        this.widgets.add(cont);
        this.scheduler.timeout(id, 3000, () => {
            this.widgets.remove(cont);
        });
    }
}
